import { createReducer, on } from '@ngrx/store';
import { Action } from '@ngrx/store';
import { Examination, ExaminationList } from '../../model/examination.model';
import * as ExaminationActions from '../actions/examination.actions';

export interface ExaminationsData {
    examinations: ExaminationList | null,
    selectedExamination: Examination | null,
    loading: boolean
}

export const initialState:ExaminationsData = {
    examinations: null,
    selectedExamination: null,
    loading: false,
};

const documentFormationReducer = createReducer(
    initialState,
    on(ExaminationActions.GetExamination, (state) => ({ ...state, loading: true })),
    on(ExaminationActions.GetExaminationfromurl, (state) => ({ ...state, loading: true })),
    on(ExaminationActions.GetExaminationSuccess, (state, action) => ({ ...state, examinations: action.payload, loading: false })),
    on(ExaminationActions.GetExaminationFailure, (state) => ({ ...state, examinations: null, loading: false })),
    on(ExaminationActions.SetExamination, (state, action) => ({ ...state, selectedExamination: action.examination, loading: false })),
);

export function reducer(state: ExaminationsData | undefined, action: Action) {
    return documentFormationReducer(state, action);
}